export default function (router) {
    router.beforeEach((to, from, next) => {
        if (!to.meta.middleware || !to.meta.middleware.mustBeAuthenticated) return next();

        const store = router.app.$store;

        if (router.app.$store.state.auth.authenticated) return next();

        const redirectUrl = to.meta.middleware.redirectBackAfterLogin
            ? '?return_url=' + window.location.origin + to.fullPath
            : '/'

        store.dispatch('auth/logout', '/login' + redirectUrl)
    })
}